import ActionType from 'actions/ActionType'

export default (
  state = {
    modalOpen: false,
    onPhone: false,
    muted: false,
    startTime: null,
    log: null,
    to: null,
  },
  action,
) => {
  switch (action.type) {
    case ActionType.Phone.TOGGLE_MODAL:
      return {
        ...state,
        modalOpen:
          typeof action.payload === 'boolean'
            ? action.payload
            : !state.modalOpen,
      }
    case ActionType.Phone.SET_STATE:
      if (typeof action.payload === 'object') {
        return {
          ...state,
          ...action.payload,
        }
      }
      return state
    case ActionType.Inbox.CALL:
      return {
        ...state,
        to: action.toNumberSelected,
      }
    default:
      return state
  }
}
